import React from 'react';
import Error from '@material-ui/icons/Error';
import { Tooltip } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';

export interface IconWithPqlNotificationProps {
  icon: JSX.Element;
  missingPql: boolean;
}

export const IconWithPqlNotification = (props: IconWithPqlNotificationProps) => {
  const { icon, missingPql } = props;
  const { t } = useTranslation();

  return (
    <div style={{ position: 'relative', width: 50, height: 50 }}>
      {icon}
      {missingPql && (
        <Tooltip title={`${t('PQL price required')}`}>
          <Error
            color="error"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: 28,
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};
